module.exports = {"screenLoader.general":"Loading common section..."}